if (!customElements.get("m-discount-cards")) {
  class MDiscountCards extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initCopyButtons();

      const enableSlider = this.dataset.enableSlider === "true";
      if (enableSlider) {
        const wrapper = this.querySelector("[data-wrapper]");
        if (wrapper) {
          wrapper.classList.add("swiper-wrapper");
          wrapper.classList.remove("discount-cards__grid--grid");
          wrapper.classList.add("discount-cards__grid--carousel");
          if ('IntersectionObserver' in window) {
            const observer = new IntersectionObserver((entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  this.initSlider();
                  observer.disconnect();
                }
              });
            }, { rootMargin: '200px' });
            observer.observe(this);
          } else {
            this.initSlider();
          }
        }
      }
    }

    initCopyButtons() {
      const copyBtns = this.querySelectorAll("[data-copy-btn]");
      copyBtns.forEach((btn) => {
        btn.addEventListener("click", (e) => {
          e.preventDefault();
          const code = btn.dataset.code;
          if (!code) return;

          this.copyToClipboard(code).then(() => {
            const originalText = btn.dataset.originalText || btn.textContent;
            btn.dataset.originalText = originalText;
            const copiedText = btn.dataset.copiedText || "COPIED!";

            btn.textContent = copiedText;
            btn.classList.add("is-copied");

            setTimeout(() => {
              btn.textContent = originalText;
              btn.classList.remove("is-copied");
            }, 2000);
          });
        });
      });
    }

    async copyToClipboard(text) {
      if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(text);
      } else {
        const textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.position = "fixed";
        textArea.style.left = "-999999px";
        textArea.style.top = "-999999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        return new Promise((resolve, reject) => {
          document.execCommand("copy") ? resolve() : reject();
          textArea.remove();
        });
      }
    }

    initSlider() {
      const autoplay = this.dataset.enableAutoplay === "true";
      const autoplaySpeed = parseInt(this.dataset.autoplaySpeed || "5");
      const itemsDesktop = parseInt(this.dataset.items || "4");
      const itemsMobile = parseInt(this.dataset.itemsMobile || "1");
      const itemsTablet = Math.min(itemsDesktop, Math.max(2, Math.ceil(itemsDesktop / 2)));
      const slideContainer = this.querySelector(".swiper-container") || this.querySelector(".swiper");

      const SwiperLib = window.Swiper || (window.MinimogLibs && window.MinimogLibs.Swiper);

      if (slideContainer && SwiperLib) {
        this.slider = new SwiperLib(slideContainer, {
          slidesPerView: itemsMobile,
          slidesPerGroup: 1,
          spaceBetween: parseInt(this.dataset.gapMobile || "15"),
          autoplay: autoplay
            ? {
                delay: autoplaySpeed * 1000,
                disableOnInteraction: false,
              }
            : false,
          loop: false,
          navigation: {
            nextEl: this.querySelector(".swiper-button-next"),
            prevEl: this.querySelector(".swiper-button-prev"),
          },
          pagination: {
            el: this.querySelector(".swiper-pagination"),
            clickable: true,
          },
          breakpoints: {
            768: {
              slidesPerView: itemsTablet,
              spaceBetween: parseInt(this.dataset.gap || "20"),
            },
            1024: {
              slidesPerView: itemsDesktop,
              spaceBetween: parseInt(this.dataset.gap || "20"),
            },
          },
        });
      }
    }
  }

  customElements.define("m-discount-cards", MDiscountCards);
}
